<template>
  <v-list subheader>
    <v-subheader>Product</v-subheader>

    <v-list-item @click="openReport('list')">
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/barcode.png"></v-img>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>Price List</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider inset></v-divider>
    <v-list-item @click="openReport('notSold')">
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/shopping-bag.png"></v-img>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>Didn't sold for last 60 days</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider inset></v-divider>
    <v-list-item>
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/refund.png"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Refund By Product</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider inset></v-divider>
    <v-list-item @click="openReport('reorder')">
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/shopping-bag.png"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Product Reorder Point</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("reportView", ["setDateSelector", "setReportName"]),
    openReport(link) {
      let routeData = this.$router.resolve({
        path: `/reportView/product/${link}`,
      });
      window.open(routeData.href, "_blank");
    },
    openDateSelector(val) {
      this.setReportName(val);
      this.setDateSelector(true);      
    },
  },
};
</script>

<style scoped></style>
